import React from 'react'
type Props = {
  alt?: string
}
function CameraUnknownIcon({alt}: Props) {
  return (
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={alt}>
<path d="M2.66699 3.33301V7.99967C2.66699 10.9452 5.05479 13.333 8.00033 13.333C10.9459 13.333 13.3337 10.9452 13.3337 7.99967V3.33301" stroke="#3D484D" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M1.33301 3.33301H14.6663" stroke="#3D484D" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.83398 10.3301V10.3359" stroke="#3D484D" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.83398 8.33057C8.13285 8.32962 8.42275 8.22843 8.6573 8.04321C8.89185 7.85798 9.05748 7.59943 9.12769 7.30893C9.19789 7.01842 9.16862 6.71277 9.04454 6.44087C8.92046 6.16898 8.70876 5.94657 8.44332 5.80924C8.1781 5.67338 7.87472 5.63125 7.58252 5.68972C7.29033 5.74818 7.02651 5.90379 6.83398 6.13124" stroke="#3D484D" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  )
}

export default CameraUnknownIcon